module.exports = __webpack_public_path__ + "c_static/img/account_certification_show_my_taobao_img.7a1472b.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/images/img/account_certification_show_my_taobao_img.jpeg
// module id = Fm12
// module chunks = 33